import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=935d5d54&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=ts"
export * from "./LocationCard.vue?vue&type=script&lang=ts"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=935d5d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d5d54",
  null
  
)

export default component.exports